import { render, staticRenderFns } from "./ContinuousFilingFilesDetails.vue?vue&type=template&id=064acef2&scoped=true&"
import script from "./ContinuousFilingFilesDetails.vue?vue&type=script&lang=js&"
export * from "./ContinuousFilingFilesDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContinuousFilingFilesDetails.vue?vue&type=style&index=0&id=064acef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064acef2",
  null
  
)

export default component.exports